// Brief 85 §2 — OpposingCounselModal, moved out of App.tsx's renderModals switch.
//
// MOVED, NOT REWRITTEN (85 §2): the body was byte-identical to the `case "ocu":`
// clause it left (sha256 0528cd89…) — until 214 §1 [RULED, ADVISOR — the list's
// order], which made ONE FORM for a counsel: the fields now live in
// OpposingCounselFields.tsx (the union of this form and the matter's quick add —
// this list's order and name check, the quick add's Notes at the end), and this
// modal and QuickAddModal both mount it with their own field builders.
//
// Props are the UNION of the names the body actually read in App scope, taken
// from a TypeScript-checker walk rather than chosen — a passed-but-unread prop
// would mean the union rule absorbed something it should have refused.
// The vocabulary props are typed by inference off makeModalFields' return, so
// this file adds nothing to the `any` ratchet.

import AddressFields from "./AddressFields";
import OpposingCounselFields from "./OpposingCounselFields"; // 214 §1 — the one form
import { ModalLayout } from "../SharedUI";
import { SK } from "../../utils";
import type { TaxList, TFn } from "../../lib/taxonomyTypes";
import type { FieldSelectOption } from "../FieldSelect";
import type { makeModalFields } from "../modalFields";

type Vocab = ReturnType<typeof makeModalFields>;
type ModalForm = { country?: string | null; id?: string | null };

type Props = {
  BarSel: Vocab["BarSel"];
  F: Vocab["F"];
  NA: Vocab["NA"];
  T: Vocab["T"]; // 214 §1 — the Notes textarea
  TitSel: Vocab["TitSel"];
  _fl: Vocab["_fl"];
  _mt: Vocab["_mt"];
  cm: () => void;
  countriesList: readonly FieldSelectOption[];
  countryEntries: TaxList;
  form: ModalForm;
  opponentLawyers: readonly unknown[];
  saveEntity: (k: string, rows: readonly unknown[], set: (v: readonly unknown[]) => void, f: unknown, ext?: Record<string, unknown>) => void;
  setOpponentLawyers: (v: readonly unknown[]) => void;
  t: TFn;
  updateField: (k: string, v: string) => void;
};

export default function OpposingCounselModal({
  BarSel,
  F,
  NA,
  T,
  TitSel,
  _fl,
  _mt,
  cm,
  countriesList,
  countryEntries,
  form,
  opponentLawyers,
  saveEntity,
  setOpponentLawyers,
  t,
  updateField,
}: Props) {
  return (
          <ModalLayout
            recordId={form.id} // 204 §G — the person's internal id in the header
            title={form.id ? _mt("Edit Opp. Counsel") : _mt("New Opp. Counsel")}
            onClose={cm}
            onSave={() =>
              saveEntity(SK.ocu, opponentLawyers, setOpponentLawyers, form, { country: form.country || null })
            }
          >
              <OpposingCounselFields
                F={F}
                T={T}
                TitSel={TitSel}
                BarSel={BarSel}
                nameAdvisor={NA({
                  pool: opponentLawyers,
                  typeLabel: t("type.counsel", { fallback: "opposing counsel" }),
                })}
                address={
                  <AddressFields
                    F={F}
                    _fl={_fl}
                    countriesList={countriesList}
                    countryEntries={countryEntries}
                    form={form}
                    t={t}
                    updateField={updateField}
                  />
                }
              />
          </ModalLayout>
  );
}
